module.exports = __webpack_public_path__ + "static/img/dl_discord.f79b34aa.png";